import '.u{width:100%;}.ssr-plugin'
import type { ReactNode } from 'react'
import { styled, type Style } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'

export type LandingSectionProps = {
  children: ReactNode
  isPadded?: boolean
  backgroundColor?: string
  style?: Style
}

const LandingSection = ({
  children,
  isPadded = false,
  backgroundColor = 'transparent',
  style,
}: LandingSectionProps) => {
  const isMobile = useMediaQuery()

  return (
    <styled.div className="u"
      style={{
        padding: isPadded ? (isMobile ? '0.5rem' : '4.5rem') : 0,
        backgroundColor,
        borderRadius: isMobile ? '0.5rem' : '3rem',
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}

export default LandingSection
